import { render, staticRenderFns } from "./MsgDialog.vue?vue&type=template&id=25fd8f5a&scoped=true"
import script from "./MsgDialog.vue?vue&type=script&lang=js"
export * from "./MsgDialog.vue?vue&type=script&lang=js"
import style0 from "./MsgDialog.vue?vue&type=style&index=0&id=25fd8f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd8f5a",
  null
  
)

export default component.exports